var Handlebars = require('C:/project/oa-cx-ent/oa-cx-ux/module/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<dt>선택된 서비스</dt>\r\n<dd></dd>";
},"useData":true});